import { Card, Row, Col } from "react-bootstrap";
import { formatCurrency } from "@/utils/formatCurrency.js";

// La moneda "DLS" es el nombre del catálogo, no un código ISO: Intl no la conoce.
const ISO_CURRENCY = { MXN: "MXN", DLS: "USD" };

const money = (value, currency) =>
  value === null || value === undefined || value === ""
    ? "-"
    : formatCurrency(value, "es-MX", ISO_CURRENCY[currency] ?? "MXN");

/**
 * Lo que el cliente capturó al pedir la factura. Es opcional: quien adjunta
 * comprobante o layout puede no capturar nada, y entonces se dice dónde buscar.
 */
const BillingAmounts = ({ bill }) => {
  const { totalWithIva, iva, descriptionsAndBillingConcepts, currency } = bill;
  const captured =
    totalWithIva != null || iva != null || !!descriptionsAndBillingConcepts;

  return (
    <Card>
      <Card.Header>Importe y conceptos</Card.Header>
      <Card.Body>
        {captured ? (
          <>
            <Row className="mb-2">
              <Col xs={12} md={4}>
                <strong>Importe con IVA:</strong>{" "}
                {money(totalWithIva, currency)}
              </Col>
              <Col xs={12} md={4}>
                <strong>IVA:</strong> {money(iva, currency)}
              </Col>
            </Row>
            <strong>Conceptos:</strong>
            <div style={{ whiteSpace: "pre-wrap" }}>
              {descriptionsAndBillingConcepts || "-"}
            </div>
          </>
        ) : (
          <div className="text-muted">
            No se capturó importe ni conceptos: revisa el documento soporte.
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default BillingAmounts;
